import { ServicesContainerConfig } from '../../models';
import { UrlParamProductPageService } from '../../services/url-param-product-page-service';

export const DEFAULT_CONTAINER_SERVICES: ServicesContainerConfig = {
  platformAdapter: 'EmpathyBrokerAdapter',
  productPageService: 'UrlParamProductPageService'
};
